// Filename: gani_report.js
// Timestamp: 2017.09.29-01:57:36 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

const gnreportCreate = (records => (key, startts = Date.now()) => ({
  id: ++records,
  initiator: key,
  endts: null,
  startts,
  timearr: [],
  patcharr: [],
  replacearr: [],
  replaceaccumarr: [],

  patchkeyobj: {},
  patchkeyarr: [],

  // dfspopulate
  tsarr: [],
  tsrmarr: [],
  tsvnodearr: [],
  delaykeyarr: []
}))(0)

const gnreport_addreplacekey = (rec, key) => (
  rec.replacearr.push(key),
  rec)

const gnreport_iskeyreplaced = (rec, key) => (
  rec.replacearr.find(repkey => (
    key.startsWith(repkey))))

const gnreportNodeSubjChangedSet = (rec, key) => (
  rec.patchkeyobj[key] = true,
  rec)

const gnreportNodeSubjChangedGet = rec => (
  Object.keys(rec.patchkeyobj))

const gnreportMarkEvKey = (rec, ev, key, bgnts, endts, now = Date.now()) => (
  rec[ev].push([(endts || now) - (bgnts || now), key]),
  rec)

const gnreportMarkNodeHydrationComplete = (rec, key, bgnts, endts) => (
  gnreportMarkEvKey(rec, 'tsarr', key, bgnts, endts))

const gnreportMarkNodeRemovalComplete = (rec, key, bgnts, endts) => (
  gnreportMarkEvKey(rec, 'tsrmarr', key, bgnts, endts))

const gnreportMarkNodeTreeComplete = (rec, key, bgnts, endts) => (
  gnreportMarkEvKey(rec, 'tsvnodearr', key, bgnts, endts))

const gnreport_getdelayunitarr = rec => (
  rec.delaykeyarr.sort(([delaynumb], [delaynuma]) => (
    delaynumb > delaynuma)).map(([, key]) => key))

const gnreportRenderTimeUnit = (timearr, msg) => timearr
  .map(([time, key]) => (
    msg.replace(':time', (`     ${time}`).substr(-5, 5))
      .replace(':key', key)
  )).join('\n')

// only key is sent --in some contexts, node may no longer
// exist in graph if 'population' involves its removal
const gnreportRender = (report, now = Date.now()) => [
  gnreportRenderTimeUnit(report.tsrmarr, ':timems  remove, :key'),
  gnreportRenderTimeUnit(report.tsarr, ':timems  populate, :key'),
  gnreportRenderTimeUnit(report.tsvnodearr, ':timems  vnode, :key'),
  gnreportRenderTimeUnit(report.delaykeyarr, ':timems  delay, :key'),
  'total: :timems, :secs'
    .replace(/:time/, now - report.startts)
    .replace(/:sec/, (now - report.startts) / 1000)
].filter(n => n).join('\n=================\n')

export {
  gnreportCreate,
  gnreportRender,
  gnreportMarkNodeHydrationComplete,
  gnreportMarkNodeRemovalComplete,
  gnreportMarkNodeTreeComplete,

  gnreportNodeSubjChangedSet,
  gnreportNodeSubjChangedGet,

  gnreport_addreplacekey,
  gnreport_iskeyreplaced,
  gnreport_getdelayunitarr
}
